/* eslint-disable no-unused-vars */
import { useState, useEffect, useMemo } from "react";

// react-router components
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Icon from "@mui/material/Icon";
// Soft UI Dashboard React components
import SuiBox from "components/SuiBox";
import AddUser from "layouts/add_patient";

// import currentLanguage from "examples/Navbars";
import TopNav from "examples/TopNav";
import Configurator from "examples/Configurator";

// Soft UI Dashboard React themes
import theme from "assets/theme";
import themeRTL from "assets/theme/theme-rtl";

// RTL plugins
import rtlPlugin from "stylis-plugin-rtl";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";

// Soft UI Dashboard React routes
import routes from "routes";

// Soft UI Dashboard React contexts
import { useSoftUIController, setMiniSidenav, setOpenConfigurator } from "context";

// Images
import brand from "assets/images/logo-ct.png";
import i18n from "i18n";
import HomeScreen from "layouts/home_screen";
import Website from "layouts/website";
import Board from "layouts/board";
import AdminRoutes from "route_admin";
import CustomerRoutes from "route_customer";

export default function App() {
  const [locale, setLocale] = useState(i18n.language);
  const [controller, dispatch] = useSoftUIController();
  const { miniSidenav, direction, layout, openConfigurator, sidenavColor } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const [rtlCache, setRtlCache] = useState(null);
  const { pathname } = useLocation();

  // Cache for the rtl
  useMemo(() => {
    const cacheRtl = createCache({
      key: "rtl",
      stylisPlugins: [rtlPlugin],
    });

    setRtlCache(cacheRtl);
  }, []);

  // Open sidenav when mouse enter on mini sidenav
  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  // Close sidenav when mouse leave mini sidenav
  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  // Change the openConfigurator state
  const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);

  // Setting the dir attribute for the body element
  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    // console.log(currentLanguage);
    // console.log(currentLanguage);
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }

      return null;
    });
  // eslint-disable-next-line no-unused-vars
  const adduser = {
    key: "adduser",
    route: "/adduser",
    // icon: <Shop size="12px" />,
    component: <AddUser />,
    noCollapse: true,
  };

  const configsButton = (
    <SuiBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      width="3.5rem"
      height="3.5rem"
      bgColor="white"
      shadow="sm"
      borderRadius="50%"
      position="fixed"
      right="2rem"
      bottom="2rem"
      zIndex={99}
      color="dark"
      sx={{ cursor: "pointer" }}
      onClick={handleConfiguratorOpen}
    >
      <Icon fontSize="default" color="inherit">
        settings
      </Icon>
    </SuiBox>
  );

  return (
    <Routes>
      {/*
        The public company site is the front door now. It sits outside the
        ThemeProvider branch below because it brings its own look and must
        never render the dashboard's top navigation.
      */}
      {["/", "/home", "/homescreen"].map((path) => (
        <Route
          key={path}
          path={path}
          element={
            /* SuiBox and SuiTypography read theme.functions and theme.borders,
               which only exist in the custom theme - the site must stay inside
               the provider even though it brings its own colours. */
            <ThemeProvider theme={theme}>
              <CssBaseline />
              <Website />
            </ThemeProvider>
          }
        />
      ))}

      {/* the wall board. Public and chrome-free: it is a screen in the
          office, not a page someone navigates. */}
      {["/board", "/test"].map((path) => (
        <Route
          key={path}
          path={path}
          element={
            <ThemeProvider theme={theme}>
              <CssBaseline />
              <Board />
            </ThemeProvider>
          }
        />
      ))}

      {/* the old posts-only landing page, still reachable if it is wanted */}
      <Route
        path="/old-home"
        element={
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <HomeScreen />
          </ThemeProvider>
        }
      />
      <Route
        path="*"
        element={
          <ThemeProvider theme={theme}>
            <CssBaseline />
            {layout === "dashboard" && (
              <>
                <TopNav
                  brandName="Trust Cargo"
                  routes={
                    sessionStorage.getItem("role_id") === "admin" ? AdminRoutes : CustomerRoutes
                  }
                />
                {/* <Configurator /> */}
                {/* {configsButton} */}
              </>
            )}
            {layout === "vr" && <Configurator />}
            <Routes>
              {getRoutes(routes)}
              <Route path="*" element={<Navigate to="/homescreen" />} />
              {/* <Route path="*" element={<Navigate to="/authentication/sign-in" />} /> */}
            </Routes>
          </ThemeProvider>
        }
      />
    </Routes>
  );
}
